import React from 'react'
import { NavLink } from 'react-router-dom'
import { VIEW } from '../../components/image'

const StoriesList = () => {

    const videoViewers = [
        {
            storyNumber: '1L',
            story: 'Story 1L',
            numberOfTimeWatch: '1000',
            averageLengthOfView: '40:13',
            numberViewer: '750',
            completeView: '228'
        },
        {
            storyNumber: '1W',
            story: 'Story 1W',
            numberOfTimeWatch: '1500',
            averageLengthOfView: '40:23',
            numberViewer: '800',
            completeView: '228'
        },
        {
            storyNumber: '2',
            story: 'Story 2',
            numberOfTimeWatch: '800',
            averageLengthOfView: '40:54',
            numberViewer: '650',
            completeView: '228'
        },
        {
            storyNumber: '3',
            story: 'Story 3',
            numberOfTimeWatch: '2000',
            averageLengthOfView: '40:59',
            numberViewer: '900',
            completeView: '228'
        },
        {
            storyNumber: '4',
            story: 'Story 4',
            numberOfTimeWatch: '1200',
            averageLengthOfView: '40:15',
            numberViewer: '780',
            completeView: '228'
        },
    ]
    return (
        <div className="tableStyle mt-5">
            <table>
                <thead>
                    <tr>
                        <th>Story No</th>
                        <th>Story name</th>
                        <th>Number of Views</th>
                        <th>Unique Viewers</th>
                        <th>Average Length of View (s)</th>
                        <th>Complete views</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {videoViewers.map((videoViewer, index) => (
                        <tr key={index}>
                            <td>{videoViewer.storyNumber}</td>
                            <td>
                                <div className="user">
                                    {videoViewer.story}
                                </div>
                            </td>
                            <td>{videoViewer.numberOfTimeWatch}</td>
                            <td>{videoViewer.numberViewer}</td>
                            <td>{videoViewer.averageLengthOfView}</td>
                            <td>{videoViewer.completeView}</td>
                            <td>
                                <NavLink
                                    state={videoViewer.story}
                                    to={'/view-video-statistics'}
                                    style={{
                                        textDecoration: 'none',
                                        color: '#000',
                                    }}
                                >
                                    <div title='View Details' ><img src={VIEW} alt='' /></div>
                                </NavLink>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default StoriesList